export default "__VITE_ASSET__BLxVrYYB__"